{
  "name": "ua-browser",
  "version": "1.4.5",
  "description": "uaBrowser - Browser, OS, engine and device detection from user agent strings. Supports Node.js. Zero dependencies.",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      },
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.mjs"
      }
    }
  },
  "files": [
    "dist"
  ],
  "sideEffects": false,
  "browserslist": [
    "chrome >= 63",
    "safari >= 12",
    "firefox >= 55",
    "edge >= 79"
  ],
  "scripts": {
    "release": "pnpm build && changeset publish",
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint src --ext .ts",
    "typecheck": "tsc -p tsconfig.build.json --noEmit",
    "docs:dev": "pnpm build && vitepress dev docs --host 0.0.0.0 --port 61199",
    "docs:build": "pnpm build && vitepress build docs",
    "docs:preview": "vitepress preview docs"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/yangtianxia/ua-browser.git"
  },
  "keywords": [
    "uaBrowser",
    "userAgent",
    "javascript",
    "typescript",
    "browser-detection",
    "user-agent-parser"
  ],
  "author": "yangtianxia",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/yangtianxia/ua-browser/issues"
  },
  "homepage": "https://github.com/yangtianxia/ua-browser#readme",
  "devDependencies": {
    "@changesets/cli": "^2.29.4",
    "@typescript-eslint/eslint-plugin": "^7.0.0",
    "@typescript-eslint/parser": "^7.0.0",
    "@vitest/coverage-v8": "^1.6.0",
    "eslint": "^8.57.0",
    "eslint-plugin-import": "^2.29.1",
    "tsup": "^8.0.2",
    "typescript": "^5.4.0",
    "vitepress": "^1.6.4",
    "vitest": "^1.6.0",
    "vue": "^3.5.32"
  }
}
